module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.pageLoading),
      expression: "pageLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "upload-copyright",
    attrs: {
      "element-loading-text": "数据上传中，请耐心等待……"
    }
  }, [_c('xi-top'), _vm._v(" "), _c('div', {
    staticClass: "upload-banner"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.uploadWork')))])]), _vm._v(" "), _c('el-form', {
    ref: "copyright",
    staticClass: "copyright-item",
    attrs: {
      "model": _vm.copyright,
      "rules": _vm.copyRules
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "30px 0",
      "font-size": "12px",
      "color": "#ccc"
    }
  }, [_vm._v("温馨提示：如果您在上传版权过程中，有任何疑问和建议，请通过邮箱与我们联系，我们将竭诚为您服务。\n            有声化平台官方邮箱：a.plus@ximalaya.com")]), _vm._v(" "), _c('el-row', [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('comb.baseInfo')))])]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "prop": "bookName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('sen.bookNameMissing')
    },
    model: {
      value: (_vm.copyright.bookName),
      callback: function($$v) {
        _vm.copyright.bookName = $$v
      },
      expression: "copyright.bookName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "prop": "author"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('sen.writerMissing')
    },
    model: {
      value: (_vm.copyright.author),
      callback: function($$v) {
        _vm.copyright.author = $$v
      },
      expression: "copyright.author"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', [_c('el-cascader', {
    attrs: {
      "expand-trigger": "click",
      "show-all-levels": false,
      "options": _vm.categoryList,
      "props": _vm.categoryProps,
      "filterable": ""
    },
    model: {
      value: (_vm.copyright.category),
      callback: function($$v) {
        _vm.copyright.category = $$v
      },
      expression: "copyright.category"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('sen.publisherHolder')
    },
    model: {
      value: (_vm.copyright.publisher),
      callback: function($$v) {
        _vm.copyright.publisher = $$v
      },
      expression: "copyright.publisher"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "ISBN"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('sen.ISBNPlaceHolder')
    },
    model: {
      value: (_vm.copyright.ISBN),
      callback: function($$v) {
        _vm.copyright.ISBN = $$v
      },
      expression: "copyright.ISBN"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "prop": "intro"
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 4,
      "type": "textarea",
      "placeholder": _vm.$t('comb.workIntro')
    },
    model: {
      value: (_vm.copyright.intro),
      callback: function($$v) {
        _vm.copyright.intro = $$v
      },
      expression: "copyright.intro"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "upload-block"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.uploadCover')))]), _vm._v(" "), _c('el-form-item', {
    staticClass: "cover-img-wrapper",
    attrs: {
      "prop": "coverImg"
    }
  }, [_c('el-upload', {
    staticClass: "cover-img-uploader",
    attrs: {
      "action": "/dtres/backend/album/upload",
      "show-file-list": false,
      "accept": "image/jpeg,image/png,image/bmp",
      "on-success": _vm.handleCoverImgSuccess,
      "before-upload": _vm.beforeCoverImgUpload
    }
  }, [(_vm.copyright.coverImg) ? _c('img', {
    staticClass: "cover-img",
    attrs: {
      "src": ("" + _vm.UPLOAD_IMG_HOST + (_vm.copyright.coverImg))
    }
  }) : _c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "line-height": "28px",
      "color": "#7b9d85",
      "margin-left": "20px"
    }
  }, [_vm._v("\n                        封面图片需包含书籍名和作者,最佳分辨率为500*500。"), _c('br'), _vm._v("\n                        上传的图片将成为该版权内容有声作品的封面图片，向主播和读者展示。请慎重选择。\n                    ")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "upload-block"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "workList"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.workFile')) + " （只支持txt, doc, docx, pdf格式文件）")]), _vm._v(" "), _vm._l((_vm.copyright.workList), function(workFile, index) {
    return _c('div', {
      staticClass: "upload-files-name"
    }, [_c('el-tag', {
      attrs: {
        "closable": true
      },
      on: {
        "close": function($event) {
          _vm.removeFile(index, 'workList')
        }
      }
    }, [_vm._v(_vm._s(workFile.name || workFile.fileName))])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-btn",
    on: {
      "click": _vm.uploadFile
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "data-list-type": "workList",
      "multiple": "multiple",
      "accept": ".txt,.docx,application/pdf,application/msword"
    },
    on: {
      "change": _vm.addWork
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('word.add')))])])], 2)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "prop": "words"
    }
  }, [_c('el-row', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "50px",
      "padding-bottom": "10px"
    }
  }, [_vm._v("内容总字数")]), _vm._v(" "), _c('div', [_c('el-input-number', {
    attrs: {
      "size": "small",
      "controls": false
    },
    model: {
      value: (_vm.copyright.words),
      callback: function($$v) {
        _vm.copyright.words = $$v
      },
      expression: "copyright.words"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('comb.authorization')))])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('span', {
    staticStyle: {
      "margin-bottom": "20px",
      "display": "block"
    }
  }, [_vm._v("请选择您的作品有声化费用承担方式")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('router-link', {
    staticStyle: {
      "color": "#fc5832",
      "font-size": "12px"
    },
    attrs: {
      "to": {
        name: 'helpCenterCopyrightManagement',
        hash: '#fee'
      },
      "target": "_blank"
    }
  }, [_vm._v("（查看区别）")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changePayType
    },
    model: {
      value: (_vm.isCopyrighterPay),
      callback: function($$v) {
        _vm.isCopyrighterPay = $$v
      },
      expression: "isCopyrighterPay"
    }
  }, [_c('el-radio', {
    staticClass: "el-col-24",
    staticStyle: {
      "color": "#666",
      "margin-bottom": "15px"
    },
    attrs: {
      "label": false
    }
  }, [_vm._v("不承担录制费用，由喜马拉雅代理制作")]), _vm._v(" "), _c('el-radio', {
    staticClass: "el-col-24",
    staticStyle: {
      "margin-left": "0",
      "color": "#666"
    },
    attrs: {
      "label": true
    }
  }, [_vm._v("愿意承担录制费用")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('span', {
    staticStyle: {
      "margin-bottom": "20px",
      "display": "block"
    }
  }, [_vm._v("您希望在平台发布的作品")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('router-link', {
    staticStyle: {
      "color": "#fc5832",
      "font-size": "12px"
    },
    attrs: {
      "to": {
        name: 'helpCenterCopyrightManagement',
        hash: '#isSolo'
      },
      "target": "_blank"
    }
  }, [_vm._v("(了解详情)")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeLicense
    },
    model: {
      value: (_vm.isSoloLicense),
      callback: function($$v) {
        _vm.isSoloLicense = $$v
      },
      expression: "isSoloLicense"
    }
  }, [_c('el-radio', {
    staticClass: "el-col-24",
    staticStyle: {
      "color": "#666",
      "margin-bottom": "15px"
    },
    attrs: {
      "label": true
    }
  }, [_vm._v("独家授权给喜马拉雅")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isCopyrighterPay) ? _c('el-radio', {
    staticClass: "el-col-24",
    staticStyle: {
      "margin-left": "0",
      "color": "#666"
    },
    attrs: {
      "label": false
    }
  }, [_vm._v("非独家授权给喜马拉雅")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "margin-bottom": "10px",
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('comb.uploadCopyrightFile')) + "（支持pdf和图片）")])]), _vm._v(" "), _c('el-row', [(_vm.$route.params.bookId) ? _c('el-col', {
    key: "$route.params.bookId",
    staticStyle: {
      "line-height": "36px"
    },
    attrs: {
      "span": 16
    }
  }, [(_vm.copyright.authFile.name) ? _c('span', {
    staticClass: "upload-label"
  }, [_vm._v(_vm._s(_vm.copyright.authFile.name))]) : _c('a', {
    staticClass: "uploaded-file",
    attrs: {
      "href": ("" + (_vm.$store.state.UPLOAD_IMG_HOST) + (_vm.copyright.authFile)),
      "target": "_blank"
    }
  }, [_vm._v("已上传的认证文件")])]) : _c('el-col', {
    staticStyle: {
      "line-height": "36px"
    },
    attrs: {
      "span": 16
    }
  }, [(_vm.copyright.authFile) ? _c('span', {
    staticClass: "upload-label"
  }, [_vm._v(_vm._s(_vm.copyright.authFile.name))]) : _c('span', {
    staticClass: "upload-label"
  }, [_vm._v("作品版权授权书")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "prop": "authFile"
    }
  }, [_c('div', {
    staticClass: "upload-btn",
    on: {
      "click": _vm.uploadFile
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "data-list-type": "authFile",
      "accept": "application/pdf, image/*"
    },
    on: {
      "change": _vm.addAuthWork
    }
  }), _vm._v(" "), (_vm.copyright.authFile) ? _c('span', {
    staticClass: "upload-link-label"
  }, [_vm._v(_vm._s(_vm.$t('word.replace')))]) : _c('span', {
    staticClass: "upload-link-label"
  }, [_vm._v(_vm._s(_vm.$t('word.add')))])])])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "36px"
    },
    attrs: {
      "span": 4
    }
  }, [(_vm.$store.state.user.author.type === 1) ? _c('a', {
    staticClass: "upload-link-label",
    attrs: {
      "href": "http://fdfs.xmcdn.com/group34/M04/EA/17/wKgJYFnpcxnA8_z9AABRG2RdMFY63.docx",
      "download": "授权书（个人）-附身份证复印件.docx"
    }
  }, [_vm._v(_vm._s(_vm.$t('word.download')) + _vm._s(_vm.$t('word.demo')))]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.author.type === 2) ? _c('a', {
    staticClass: "upload-link-label",
    attrs: {
      "href": "http://fdfs.xmcdn.com/group34/M04/EA/1C/wKgJYFnpc0iB2ChcAABRFbmfFIM39.docx",
      "download": "授权书（公司）-附营业执照.docx"
    }
  }, [_vm._v(_vm._s(_vm.$t('word.download')) + _vm._s(_vm.$t('word.demo')))]) : _vm._e()])], 1), _vm._v(" "), (_vm.$store.state.user.author.type === 2) ? _c('el-row', [(_vm.$route.params.bookId) ? _c('el-col', {
    key: "$route.params.bookId",
    staticStyle: {
      "line-height": "36px"
    },
    attrs: {
      "span": 16
    }
  }, [(_vm.copyright.retrospectFile.name) ? _c('span', {
    staticClass: "upload-label"
  }, [_vm._v(_vm._s(_vm.copyright.retrospectFile.name))]) : _c('a', {
    staticClass: "uploaded-file",
    attrs: {
      "href": ("" + (_vm.$store.state.UPLOAD_IMG_HOST) + (_vm.copyright.retrospectFile)),
      "target": "_blank"
    }
  }, [_vm._v("已上传的追溯文件")])]) : _c('el-col', {
    staticStyle: {
      "line-height": "36px"
    },
    attrs: {
      "span": 16
    }
  }, [(_vm.copyright.retrospectFile) ? _c('span', {
    staticClass: "upload-label"
  }, [_vm._v(_vm._s(_vm.copyright.retrospectFile.name))]) : _c('span', {
    staticClass: "upload-label"
  }, [_vm._v("版权追溯文件")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "prop": "retrospectFile"
    }
  }, [_c('div', {
    staticClass: "upload-btn",
    on: {
      "click": _vm.uploadFile
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "data-list-type": "retrospectFile",
      "accept": "application/pdf, image/*"
    },
    on: {
      "change": _vm.addAuthWork
    }
  }), _vm._v(" "), (_vm.copyright.retrospectFile) ? _c('span', {
    staticClass: "upload-link-label"
  }, [_vm._v(_vm._s(_vm.$t('word.replace')))]) : _c('span', {
    staticClass: "upload-link-label"
  }, [_vm._v(_vm._s(_vm.$t('word.add')))])])])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "36px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('span', {
    staticClass: "upload-link-label",
    staticStyle: {
      "color": "#382471"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_vm._v("\n                        请提供《出版合同》，《数字出版协议》等版权追溯"), _c('br'), _vm._v("\n                        文件，以证明贵社拥有有声改编权。如原合同没有这"), _c('br'), _vm._v("\n                        项权利的，需要跟作者补签协议，并重新提交追溯文件。\n                    ")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "30px 0 15px",
      "font-size": "14px"
    }
  }, [_c('span', [_vm._v("版权有效期")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "版权授权时间应大于三年",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "icon icon-18 va-sub icon-question-circle",
    staticStyle: {
      "margin-left": "10px",
      "background-color": "black",
      "border-radius": "50%"
    }
  })])], 1), _vm._v(" "), _c('el-row', [_c('el-row', [_c('el-form-item', {
    attrs: {
      "prop": "copyrightLimit"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "placeholder": _vm.$t('sen.copyrightLimitMissing')
    },
    model: {
      value: (_vm.copyright.copyrightLimit),
      callback: function($$v) {
        _vm.copyright.copyrightLimit = $$v
      },
      expression: "copyright.copyrightLimit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "60px"
    }
  }, [_c('el-checkbox', {
    staticStyle: {
      "color": "#666",
      "float": "none"
    },
    model: {
      value: (_vm.isAgree),
      callback: function($$v) {
        _vm.isAgree = $$v
      },
      expression: "isAgree"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('word.agree'))), _c('el-button', {
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openProtocol($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.protocolText))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isAgree || _vm.pageLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('comb.commitToAudit')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('comb.licenseAgreement')
    },
    model: {
      value: (_vm.showSoloProtocol),
      callback: function($$v) {
        _vm.showSoloProtocol = $$v
      },
      expression: "showSoloProtocol"
    }
  }, [_c('release-solo-protocol', {
    on: {
      "agreementResult": _vm.setAgreementResult
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('comb.licenseAgreement')
    },
    model: {
      value: (_vm.showProtocol),
      callback: function($$v) {
        _vm.showProtocol = $$v
      },
      expression: "showProtocol"
    }
  }, [_c('release-protocol', {
    on: {
      "agreementResult": _vm.setAgreementResult
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('comb.licenseAgreement')
    },
    model: {
      value: (_vm.showSoloCustomPayProtocol),
      callback: function($$v) {
        _vm.showSoloCustomPayProtocol = $$v
      },
      expression: "showSoloCustomPayProtocol"
    }
  }, [_c('release-solo-custom-pay-protocol', {
    on: {
      "agreementResult": _vm.setAgreementResult
    }
  })], 1), _vm._v(" "), _c('xi-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-309c2f39!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/UploadCopyright.vue
// module id = 1016
// module chunks = 0